// extracted by mini-css-extract-plugin
module.exports = {"productHeader":"ProductHeader_productHeader__FPlV_","buttonWrap":"ProductHeader_buttonWrap__wiD9h"};